import ModalLinkController from "./modal_link_controller";

export default class extends ModalLinkController {
  getIdentifier() {
    return "help-modal";
  }
}
